import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import About from './pages/About';
import Artists from './pages/Artists';
import Music from './pages/Music';
import Beats from './pages/Beats'; // ✅ Import Beats Page
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Contact from './pages/Contact'; 
import './styles.css'; // Import global styles

function App() {
  return (
    <Router>
      <Header />
      <Navbar />
      <div className="container mt-5">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/artists" element={<Artists />} />
          <Route path="/music" element={<Music />} />
          <Route path="/beats" element={<Beats />} /> {/* ✅ Added Beats Route */}
          <Route path="/shop" element={<Shop />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;